import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CpuIcon } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-24 bg-dark relative overflow-hidden" data-id="element-257">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" data-id="element-258"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-260">
          <span className="text-primary font-display font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-261">
            Presentamos
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-white mb-8 uppercase tracking-tight" data-id="element-262">
            El Ecosistema{' '}
            <span className="text-primary text-glow" data-id="element-263">Sniper Panel</span>
          </h2>

          <div className="glass-panel p-8 md:p-12 rounded-sm box-glow" data-id="element-264">
            <p className="text-xl md:text-2xl text-gray-200 leading-relaxed font-light mb-8" data-id="element-265">
              Hemos fusionado la velocidad de un algoritmo institucional con el
              control total del trader humano.
            </p>

            <div className="grid md:grid-cols-2 gap-8 text-left" data-id="element-266">
              <div className="flex gap-4" data-id="element-267">
                <ShieldCheckIcon className="w-8 h-8 text-primary shrink-0" data-id="element-268" />
                <div data-id="element-269">
                  <h4 className="font-display font-bold text-white mb-2" data-id="element-270">
                    Gestión de Riesgo Instantánea
                  </h4>
                  <p className="text-gray-400" data-id="element-271">
                    El sistema blinda tu capital antes de que pulses el botón.
                    Sin cálculos manuales, sin errores.
                  </p>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-272">
                <CpuIcon className="w-8 h-8 text-primary shrink-0" data-id="element-273" />
                <div data-id="element-274">
                  <h4 className="font-display font-bold text-white mb-2" data-id="element-275">
                    Sinergia Humano-Máquina
                  </h4>
                  <p className="text-gray-400" data-id="element-276">
                    Tú pones la visión y el análisis, el Panel pone las reglas
                    inquebrantables y la ejecución milimétrica.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}